<template>
  <div class="wrapper" style="background-color: #ffffff">
    <div class="section">
      <div class="container">
        <div class="md-layout md-alignment-center">
          <div class="md-layout-item md-size-50 md-alignment-center">
            <img src="ateshgah.png" alt="" />
          </div>
        </div>
        <div v-if="notsent">
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-medium-size-50">
              <h3 class="text-center">
                Xahiş edirik xidmətimizi qiymətləndirəsiniz
              </h3>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-medium-size-50">
              <md-card>
                <md-card-content>
                  <h4 class="title">Həkim qəbulunda oldunuzmu?</h4>

                  <md-radio v-model="visit" :value="true">
                    <span style="font-size: 14pt"> Bəli </span>
                  </md-radio>
                  <md-radio v-model="visit" :value="false">
                    <span style="font-size: 14pt"> Xeyr </span>
                  </md-radio>
                </md-card-content>
              </md-card>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-medium-size-50">
              <md-card>
                <md-card-content>
                  <h4 class="title">
                    Atəşgah sığorta əməkdaşının çevikliyi və rəftarı?
                    <vue-feedback-reaction
                      v-model="feedback1"
                      emojiWidth="40px"
                      emojiHeight="40px"
                      :labels="labels"
                      labelClass="feedback-labels"
                    />
                  </h4>
                </md-card-content>
              </md-card>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-medium-size-50">
              <md-card>
                <md-card-content>
                  <h4 class="title">
                    Atəşgah sığorta əməkdaşının ünsiyyəti və çevikliyi?
                    <vue-feedback-reaction
                      v-model="feedback2"
                      emojiWidth="40px"
                      emojiHeight="40px"
                      :labels="labels"
                      labelClass="feedback-labels"
                    />
                  </h4>
                </md-card-content>
              </md-card>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-medium-size-50">
              <md-card class="md-card-product">
                <md-card-content>
                  <h4 class="title">
                    Klinikanın əməkdaşlarının xidmət səviyyəsi?
                    <vue-feedback-reaction
                      v-model="feedback3"
                      emojiWidth="40px"
                      emojiHeight="40px"
                      :labels="labels"
                      labelClass="feedback-labels"
                    />
                  </h4>
                </md-card-content>
              </md-card>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-medium-size-50">
              <md-card>
                <md-card-content>
                  <h4 class="title">Həkimin qəbulu?</h4>
                  <vue-feedback-reaction
                    v-model="feedback4"
                    emojiWidth="40px"
                    emojiHeight="40px"
                    :labels="labels"
                    labelClass="feedback-labels"
                  />
                </md-card-content>
              </md-card>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-medium-size-50">
              <md-card>
                <md-card-content>
                  <h4 class="title">
                    Qeydləriniz (təkliflər, iradlar)
                    <md-field maxlength="5">
                      <label>Mətni buraya daxil edə bilərsiniz</label>
                      <md-textarea v-model="notes" />
                    </md-field>
                  </h4>
                </md-card-content>
              </md-card>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-medium-size-50">
              <md-button
                style="width: 100%"
                @click="notsent = false"
                class="md-primary"
              >
                Göndər
              </md-button>
            </div>
          </div>
        </div>
        <div v-else>
          <h2 style="color: #00c853" class="text-center">Təşəkkür edirik!</h2>

          <h6 class="text-center">Sizin rəyiniz göndərildi</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueFeedbackReaction } from "vue-feedback-reaction";
export default {
  components: {
    VueFeedbackReaction,
  },
  data() {
    return {
      visit: "",
      notsent: true,
      feedback1: "",
      feedback2: "",
      feedback3: "",
      feedback4: "",
      notes: "",
      //   labels: ["Pis", "Məyus", "Adi", "Yaxşı", "Əla"],
      labels: ["", "", "", "", ""],
    };
  },
  methods: {
    onReact() {
      console.log(this.feedback);
    },
  },
};
</script>

<style lang="scss">
.feedback-labels {
  display: none;
}
.vue-reaction .animated {
  animation: none !important;
}
</style>